import {
  ADD_NINJA_DIALOG_CLOSE,
  ADD_NINJA_DIALOG_FORM,
  ADD_NINJA_DIALOG_OPEN,
  UPDATE_NINJA_DIALOG_FORM,
} from './action-types';

export const addNinjaDialogClose = () => ({
  type: ADD_NINJA_DIALOG_CLOSE,
});

export const addNinjaDialogForm = addNinjaObject => ({
  type: ADD_NINJA_DIALOG_FORM,
  payload: addNinjaObject,
});

export const addNinjaDialogOpen = () => ({
  type: ADD_NINJA_DIALOG_OPEN,
});

export const ninjaFormUpdate = form => ({
  type: UPDATE_NINJA_DIALOG_FORM,
  payload: form,
});



/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/add-ninja-dialog/action-creators.js
 **/